import { HTMLAttributes } from 'react';

interface CardFormProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'dotted';
}

export const CardForm = ({
  className,
  variant = 'default',
  ...props
}: CardFormProps) => {
  const styleBorder = {
    dotted: 'bg-rock-grey border-dotted',
    default: 'bg-charcoal border-solid',
  };

  return (
    <div
      className={`${styleBorder[variant]} shadow-xs border border-primary p-8 relative ${className}`}
      {...props}
    />
  );
};
